import React from 'react';

import PlusIcon from '../../../icons/PlusIcon';
import BetbookProfileCheckIcon from '../../../icons/svg/betbook-profile-check-icon-sv.svg';
import { Button } from '../../button/Button';
import { useBetbookProfileContext } from '../BetbookProfileContext';
import { SvgIcon } from '../../../icons/SvgIcon';
import i18n from '../../../common/i18n';
import { dispatch } from 'nike-re-framejs';
import { subscribeToBetbookAuthor, unsubscribeFromBetbookAuthor } from '../../notifications/handlers';

export default function ProfileButtonFollow({ authorNickname, following, simplified }) {
    const { RequestNotificationPermission } = useBetbookProfileContext();
    const label = following ? i18n('nui.betbook.profile.followed.author') : i18n('nui.betbook.profile.follow.author');

    function click() {
        following
            ? dispatch(unsubscribeFromBetbookAuthor(authorNickname))
            : dispatch(subscribeToBetbookAuthor(authorNickname));
    }
    return (
        <RequestNotificationPermission>
            {simplified ? (
                <button className="p-0" onClick={click} data-atid="betbook-profile-follow">
                    {following ? (
                        <SvgIcon imgId="notification-yellow" sizeX="20px" sizeY="20px" />
                    ) : (
                        <SvgIcon imgId="notification-grey" sizeX="20px" sizeY="20px" />
                    )}
                </button>
            ) : (
                <Button
                    className="betbook-profile-button blue"
                    icon={following ? BetbookProfileCheckIcon : PlusIcon}
                    label={label}
                    large
                    primary={following}
                    onClick={click}
                    dataAtid="betbook-profile-follow"
                />
            )}
        </RequestNotificationPermission>
    );
}
